import { put, select, takeLatest } from "redux-saga/effects";

import FileTag from "@mapmycustomers/shared/types/entity/FileTag";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import { callApi } from "../api/callApi";
import { handleError } from "../errors/actions";
import { getOrganizationId } from "../iam";

import { fetchAllFileTags } from "./actions";

export function* onFetchAllFileTags() {
  try {
    const organizationId: Organization["id"] = yield select(getOrganizationId);
    const response: ListResponse<FileTag> = yield callApi("fetchFileTags", organizationId, {
      $limit: 10000,
      $order: "name",
    });
    yield put(fetchAllFileTags.success(response.data));
  } catch (error) {
    yield put(fetchAllFileTags.failure());
    yield put(handleError({ error }));
  }
}

export function* fileTagsSaga() {
  yield takeLatest(fetchAllFileTags.request, onFetchAllFileTags);
}
